import React from "react";
import SelectX from "../../../../../../components/Form/SelectX";
import {
  fetchAssignees,
  fetchProjects,
} from "../../../../../../components/CommonFunctions/DropdownLists";
import { Box } from "@mui/material";

function Dropdowns({ watch, setValue, control }) {



  return (
    <Box mt={3}>
      <SelectX

        options={fetchAssignees}
        label="Assign To"
        name={"assing_to_users"}
        defaultValue={watch("assing_to_users")}
        control={control}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          // singleValue: (base, state) => {
          //     return {
          //         ...base,
          //         backgroundColor: state.data.bg_color,
          //         fill: state.data.text_color
          //     };
          // },

          multiValue: (base, state) => {
            return {
              ...base,
              backgroundColor: state.data.bg_color,
              fill: state.data.text_color,
            };
          },

          multiValueLabel: (base, state) => ({
            ...base,
            backgroundColor: "hsl(0, 0%, 90%)",
            color: state.data.text_color,
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: "black",
            backgroundColor: "hsl(0, 0%, 90%)",
          }),
        }}
      />
      <Box mt={2}>
        <SelectX
    
          options={fetchProjects}
          label="Project"
          name={"assign_project"}
          defaultValue={watch("assign_project")}
          control={control}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            // singleValue: (base, state) => {
            //     return {
            //         ...base,
            //         backgroundColor: state.data.bg_color,
            //         fill: state.data.text_color
            //     };
            // },

            multiValue: (base, state) => {
              return {
                ...base,
                backgroundColor: state.data.bg_color,
                fill: state.data.text_color,
              };
            },

            multiValueLabel: (base, state) => ({
              ...base,
              backgroundColor: "hsl(0, 0%, 90%)",
              color: state.data.text_color,
            }),
            multiValueRemove: (base) => ({
              ...base,
              color: "black",
              backgroundColor: "hsl(0, 0%, 90%)",
            }),
          }}
        />
      </Box>
    </Box>
  );
}

export default Dropdowns;
